import React, { useState } from 'react'
import { NavLink, useNavigate  } from 'react-router-dom'
import { useSelector } from 'react-redux'
import configData from "../config.json";


const Navbar = () => {

    const navigate = useNavigate();

    const handleLogout = () => {
        // remove stored login data
        localStorage.removeItem('eshopBranchID');

        // redirect to login page
        navigate("/adminLogin");
    }

    return (
        <div className="container" >  
            <nav className="navbar navbar-expand-sm bg-info py-3 sticky-top" style={{ background: "linear-gradient(to right, #384654ff, #94b6deff)"}} >
                        
                <NavLink className="navbar-brand fw-bold fs-4 px-2" to="/admin">
                <img className="" src={configData.IMAGE_URL+"/bseceshop.png"} height={50}/>
                </NavLink>

                {/* Logout Button */}
                <div className="ms-auto px-3">
                    <button className="btn btn-danger btn-sm fw-bold" onClick={handleLogout}>
                        Logout
                    </button>
                </div>

            </nav>
        </div>
    )

}

export default Navbar